import PropTypes from "prop-types";
import React from "react";
import MiscPageLayout from "../../components/FullPageLayout/MiscPageLayout";
import { Typography, Box, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router";
import { connect } from "react-redux";

const useStyles = makeStyles(theme => ({
  button: {
    marginTop: theme.spacing(6),
    minWidth: 153
  }
}));

const LoggedOut = ({ push }) => {
  const classes = useStyles();
  const onLoginClick = () => {
    push("/vision/login"); // TODO: change to correct login url after login page implementation
  };
  return (
    <MiscPageLayout
      title={<Typography variant="h1">You have been logged out.</Typography>}
    >
      <Box display="flex" flexDirection="column" mt={8} alignItems="flex-start">
        <Typography variant="h4" color="textSecondary">
          Thank you! Come back again.
        </Typography>
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          onClick={onLoginClick}
        >
          Log In
        </Button>
      </Box>
    </MiscPageLayout>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ push }, dispatch);
}

export default connect(null, mapDispatchToProps)(LoggedOut);

LoggedOut.propTypes = {
  push: PropTypes.func
};
